import { render, staticRenderFns } from "./modal-reward.vue?vue&type=template&id=b3819818&"
import script from "./modal-reward.vue?vue&type=script&lang=js&"
export * from "./modal-reward.vue?vue&type=script&lang=js&"
import style0 from "./modal-reward.vue?vue&type=style&index=0&id=b3819818&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports